import React from "react";
import {Helmet} from "react-helmet";

class PageTitle extends React.Component {

  	render() {
		return (
			<div className="Page_Title">
	            <Helmet>
			        <title>IT Business Solutions &amp; Services for Industries | Digipanda</title>
			        <meta name="description" content="Digipanda Web Development" />
			    </Helmet>
			</div>
		);
	}
};

export default PageTitle;
